<script lang="ts">
	import LeaderBoardTimerItem from '$lib/leaderboard/LeaderBoardTimerItem.svelte';
	import { timePassedComponents } from '$lib/time';
	import SeasonTimerItem from '$lib/home/tradingRewards/TimerItem.svelte';
	export let countdownTo: number;

	let countdown: any = timePassedComponents(countdownTo);

	// update countdown every second
	setInterval(() => {
		countdown = timePassedComponents(countdownTo);
	}, 1000);

	export let color = 'text-fx-grey-100';
	export let fontWeight = 'font-semibold';
	export let size = '';
</script>

<div class="flex gap-2.5 items-center">
	<SeasonTimerItem name="d" time={countdown['day']} {color} {fontWeight} {size} />
	<SeasonTimerItem name="h" time={countdown['hour']} {color} {fontWeight} {size} />
	<SeasonTimerItem name="m" time={countdown['minute']} {color} {fontWeight} {size} />
</div>
